var _APP_CONFIGURATION$co, _process$env$NEXT_PUB, _ref, _process$env$NEXT_PUB2;
import APP_CONFIGURATION from "./app.config";
export const DEFAULT_APP = "hotels";
export const IS_BROWSER = typeof window !== "undefined";
export const NO_FARE_FAMILY = 'recommendation-without-explicit-family';
export const HEADER_REQUEST_ID = 'x-request-id';
export const SIZES = {
  xs: 12,
  sm: 14,
  base: 16,
  lg: 18,
  xl: 20,
  '2xl': 24,
  '3xl': 30,
  '4xl': 36
};
export const BREAKPOINTS = {
  xs: 450,
  sm: 640,
  md: 780,
  lg: 1024,
  xl: 1280,
  x1l: 1350,
  xxl: 1500
};
export const MAX_PAGE_SIZE_VALUE = 20;
export const MIN_PAGE_SIZE_VALUE = 1;
export const PRODUCTS_BEFORE_AD_AMOUNT = 3;
export const MAX_QUANTITY_PER_PRODUCT = 30;
export const HIDDEN_VALUE_DOTS = "••••";
export const INLINE_SEPARATION_DOT = "•";
export const DOT_TEXT = ".";
export const INLINE_RIGHT_ARROW = "→";
export const INLINE_TRADE_ARROW = "⇄";
export const DEFAULT_CURRENCY_SYMBOL = "$";
export const DEFAULT_CURRENCY = "USD";
export const DOT_TEXT_CENTERED = "·";
export const SKELETON_OPTIONS = [{
  key: 1,
  value: null
}, {
  key: 2,
  value: null
}, {
  key: 3,
  value: null
}];
export const EMAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const TEST_EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const ALPHABETIC_REGEX = /^[a-zA-Z\s]*$/;
export const ALPHA_NUMERIC_REGEX = /^[a-zA-Z0-9\s]*$/;
export const NUMERIC_REGEX = /^[0-9]*$/;
export const DATE_FORMAT = "DD/MM/YYYY";
export const DEFAULT_RETAIL_API_BASE_URL = "http://localhost:3001";
export const DEFAULT_SHARED_API_BASE_URL = "http://localhost:3000/shared/api";
export const GENDER_OPTIONS = [{
  key: "F",
  value: "FEMALE"
}, {
  key: "M",
  value: "MALE"
}, ...(process.env.NEXT_PUBLIC_ALLOW_GENDER_OTHER === "true" ? [{
  key: "O",
  value: "OTHER"
}] : [])];
export const MARITAL_STATUS_OPTIONS = [{
  key: "MA",
  value: "MARRIED"
}, {
  key: "WI",
  value: "WIDOW"
}, {
  key: "SE",
  value: "SEPARATED"
}, {
  key: "DI",
  value: "DIVORCED"
}, {
  key: "SI",
  value: "SINGLE"
}];
export const LOCALES = process.env.NEXT_PUBLIC_LOCALES || 'es,en';
export const DEFAULT_LOCALE = process.env.NEXT_PUBLIC_DEFAULT_LOCALE || 'en';
export const LANGUAGE_OPTIONS = [{
  key: "es",
  value: "SPANISH"
}, {
  key: "en",
  value: "ENGLISH"
}];
export const PASSENGER_DOCUMENT_LENGTH = {
  PP: 15,
  NI: 8
};
export const DEFAULT_DOCUMENT_MAX_LENGTH = 15;
export const DOCUMENT_TYPE_OPTIONS = [{
  key: "PP",
  value: "Flights.CHECKOUT.PASSENGERS_PAGE.TYPE_PASSPORT",
  length: PASSENGER_DOCUMENT_LENGTH.PP
}, {
  key: "NI",
  value: "Flights.CHECKOUT.PASSENGERS_PAGE.TYPE_IDENTITY_CARD",
  length: PASSENGER_DOCUMENT_LENGTH.NI
}];
export const TITLE_NAME_OPTIONS = [{
  key: "Mr",
  value: "Mr."
}, {
  key: "Mrs",
  value: "Mrs."
}, {
  key: "Ms",
  value: "Ms."
}, {
  key: "Dr",
  value: "Dr."
}];
export const ANIMATION_DURATIONS_MS = {
  fast: 150,
  normal: 300,
  slow: 500
};
export const APP_CURRENCIES = [
// DISABLE CRC FOR NOW
// {
//   id: 8998,
//   currency_code: "CRC",
//   currency_symbol: "₡",
// },
{
  id: 9006,
  currency_code: "USD",
  currency_symbol: "$"
}, {
  id: 9007,
  currency_code: "PEN",
  currency_symbol: "S/"
}];
export const BASE_DLOCAL_INPUT_STYLE = {
  fontSize: "12px",
  fontWeight: "400",
  borderRadius: (_APP_CONFIGURATION$co = APP_CONFIGURATION.config.forms) === null || _APP_CONFIGURATION$co === void 0 ? void 0 : _APP_CONFIGURATION$co.borderRadius,
  display: "block",
  width: "100%",
  lineHeight: "36px",
  color: APP_CONFIGURATION.colors.primary_text,
  backgroundColor: "transparent",
  backgroundClip: "padding-box",
  border: "0.5px solid " + APP_CONFIGURATION.colors.border,
  transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
  "::placeholder": {
    color: "#b8b6b6"
  },
  ":focus": {
    outline: "none",
    borderColor: "#2b6cb0",
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)"
  }
};
export const FLIGHT_RESULTS_PAGE_SIZE = 10;
export const SELECT_FLIGHTS_CALENDAR_OFFSET = 3;
export const HOTELS_MAX_GUEST_IN_RESERVATION = 20;
export const HOTELS_MAX_ROOMS_IN_RESERVATION = 8;

// TODO: DEFINE HOTELS SORT OPTIONS
export const HOTELS_SORT_OPTIONS = [{
  key: "RECOMMENDED",
  value: "RECOMMENDED"
}, {
  key: "PRICE_ASC",
  value: "PRICE_ASC"
}, {
  key: "PRICE_DESC",
  value: "PRICE_DESC"
}, {
  key: "STARS_ASC",
  value: "STARS_ASC"
}, {
  key: "STARS_DESC",
  value: "STARS_DESC"
}, {
  key: "NAME_ASC",
  value: "NAME_ASC"
}, {
  key: "NAME_DESC",
  value: "NAME_DESC"
}];
export const DEFAULT_FOOTER = "footer-default";
export const DEFAULT_PAYMENT_GATEWAY = "dlocal";
export const DEFAULT_LANDING_PAGE = "explore";

/*
export const HOTELS_AVAILABLE_FILTERS = [
  {
    label: "ACCOMMODATION_TYPE",
    key: "accommodation_type",
    type: FilterType.CHECKBOX,
    fixedOpen: false,
    openByDefault: true,
    filters: [
      {
        key: "1",
        label: "HOTEL",
        selected: false,
        // imageUrl:"https://cdn.agentcars.com/images/common/logos-rac/thriftyL.png"
      },
      {
        key: "16",
        label: "APARTMENT",
        selected: false,
      },
      {
        key: "22",
        label: "APARTHOTEL",
        selected: false,
        // imageUrl:"https://cdn.agentcars.com/images/common/logos-rac/dollarL.png"
      },
      {
        key: "24",
        label: "CAMPSITE",
        selected: false,
      },
      {
        key: "26",
        label: "HOSTAL",
        selected: false,
      },
      {
        key: "29",
        label: "COUNTRY_HOUSE",
        selected: false,
      },
      {
        key: "3",
        label: "RESORT",
        selected: false,
      },
    ],
  },
  {
    label: "RATING",
    key: "stars",
    type: FilterType.RATING,
    fixedOpen: false,
    openByDefault: true,
    filters: [
      {
        key: 0,
        selected: false,
        label: 'NO_RATING'
      },
      {
        key: 1,
        selected: false,
        label: '1_STAR'
      },
      {
        key: 2,
        selected: false,
        label: '2_STARS'
      },
      {
        key: 3,
        selected: false,
        label: '3_STARS'
      },
      {
        key: 4,
        selected: false,
        label: '4_STARS'
      },
      {
        key: 5,
        selected: false,
        label: '5_STARS'
      },
    ],
  },

  /*
  {
    label: "AMENTIES",
    key: "amenties",
    type: FilterType.CHECKBOX,
    fixedOpen: false,
    filters: [
      {
        key: "0",
        label: "test",
        selected: false,
      }
    ]

  },
  {
    label: "FOOD_AND_DRINKS",
    key: "food_and_drinks",
    type: FilterType.CHECKBOX,
    fixedOpen: false,
    filters: [
      {
        key: "0",
        label: "test",
        selected: false,
      }
    ]
  },
  {
    label: "FEE",
    key: "fee",
    type: FilterType.SLIDER,
    fixedOpen: false,
    min: 0,
    max: 1000,
    valuesFormat: "money",
    filters: [
      {
        key: 0,
        selectedMin: 0,
        selectedMax: 1000,
      },
    ],
  },
  {
    label: "NEAR_THE_CENTER",
    key: "near_the_center",
    type: FilterType.CHECKBOX,
    fixedOpen: false,
    filters: [
      {
        key: "0",
        label: "test",
        selected: false,
      }
    ]
  },
  {
    label: "SPECIAL_OFFERS",
    key: "special_offers",
    type: FilterType.CHECKBOX,
    fixedOpen: false,
    filters: [
      {
        key: "0",
        label: "test",
        selected: false,
      }
    ]
  },
  {
    label: "HOTEL_CHAIN",
    key: "hotel_chain",
    type: FilterType.CHECKBOX,
    fixedOpen: false,
    filters: [
      {
        key: "0",
        label: "test",
        selected: false,
      }
    ]
  },
] as PageFilters
*/

export let SortCriteria = /*#__PURE__*/function (SortCriteria) {
  SortCriteria[SortCriteria["RECOMMENDED"] = 0] = "RECOMMENDED";
  SortCriteria[SortCriteria["PRICE_ASC"] = 1] = "PRICE_ASC";
  SortCriteria[SortCriteria["PRICE_DESC"] = 2] = "PRICE_DESC";
  SortCriteria[SortCriteria["STARS_ASC"] = 3] = "STARS_ASC";
  SortCriteria[SortCriteria["STARS_DESC"] = 4] = "STARS_DESC";
  SortCriteria[SortCriteria["NAME_ASC"] = 5] = "NAME_ASC";
  SortCriteria[SortCriteria["NAME_DESC"] = 6] = "NAME_DESC";
  return SortCriteria;
}({});
export let CarsSortCriteria = /*#__PURE__*/function (CarsSortCriteria) {
  CarsSortCriteria[CarsSortCriteria["RECOMMENDED"] = 0] = "RECOMMENDED";
  CarsSortCriteria[CarsSortCriteria["PRICE_LOW_TO_HIGH"] = 1] = "PRICE_LOW_TO_HIGH";
  CarsSortCriteria[CarsSortCriteria["PRICE_HIGH_TO_LOW"] = 2] = "PRICE_HIGH_TO_LOW";
  return CarsSortCriteria;
}({});
export const CLIP_PATHS = {
  landing_path: "polygon(0% 0%, 100% 0%, 71% 100%, 0% 100%)",
  landing_path_mobile: "polygon(0% 0%, 100% 29%, 100% 100%, 0% 100%)"
};
export const RECCOMENDATIONS_DESTINATION_NAME = 'Lima';
export const restrictedCarFilters = ["M", "A"];
const paginationType = (_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_FLIGHT_PAGINATION_TYPE) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : "infinite";
export let FlightPaginationTypes = /*#__PURE__*/function (FlightPaginationTypes) {
  FlightPaginationTypes["INFINITE"] = "infinite";
  FlightPaginationTypes["PAGINATION"] = "pagination";
  FlightPaginationTypes["LOAD_MORE"] = "load_more";
  return FlightPaginationTypes;
}({});
export const FlightSelectConfig = {
  paginationType: (_ref = paginationType) !== null && _ref !== void 0 ? _ref : FlightPaginationTypes.INFINITE,
  enableFlightCalendar: ((_process$env$NEXT_PUB2 = process.env.NEXT_PUBLIC_FLIGHTS_ENABLE_FLIGHT_CALENDAR) !== null && _process$env$NEXT_PUB2 !== void 0 ? _process$env$NEXT_PUB2 : "true") === "true"
};
export const MODIFIER_CALENDAR_CLASS_NAMES = {
  'low': 'bg-calendar-low',
  'medium': 'bg-calendar-medium',
  'high': 'bg-calendar-high'
};
export const MAX_STAY_DURATION_DAYS = 29;
export const PRODUCTS_LIST = {
  FLIGHTS: "flights",
  CARS: "cars",
  HOTELS: "hotels",
  MILLASBENEFIT: "millasbenefit"
};
export const PAYMENT_PROVIDERS = {
  DLOCAL: "DLOCAL",
  IZIPAY: "IZIPAY"
};
export const LOGIN_MODE = {
  TOKEN_PARAMS: "token_param",
  FORM: "form",
  IFRAME: "iframe"
};
export const REGISTER_MODE = {
  PRE_REGISTRATION: "pre_registration",
  NO_REGISTRATION: "no_registration",
  FULL_REGISTRATION: "full_registration"
};